import { Text } from 'bold-ui'

interface ProfissionalListLabelProps {
  nome?: string
  temNomeSocial?: boolean
  nomeCivil?: string
  cbo?: string
  ineEquipe?: string
  nomeEquipe?: string
}

export const ProfissionalListLabel = (props: Readonly<ProfissionalListLabelProps>) => {
  const { nome, temNomeSocial, nomeCivil, cbo, ineEquipe, nomeEquipe } = props

  return (
    <Text>
      {nome}
      {temNomeSocial && ' (Nome social)'}
      {cbo && ` | ${cbo.titleCase()}`}
      {ineEquipe ? ` | ${nomeEquipe} - ${ineEquipe}` : ' | Sem equipe'}
      {temNomeSocial && nomeCivil && ` | Nome civil - ${nomeCivil}`}
    </Text>
  )
}
